<template>
  <div class="company-intro-container">
    <!-- 公司简介横幅 -->
    <section
      class="company-banner"
      data-aos="fade-down"
      data-aos-duration="1000"
    >
      <div class="banner-content">
        <h1 data-aos="fade-up" data-aos-duration="800">
          {{ companyInfo.name }}
        </h1>
        <p data-aos="fade-up" data-aos-duration="800" data-aos-delay="200">
          {{ companyInfo.slogan }}
        </p>
        <el-button
          type="primary"
          :style="{ backgroundColor: themeColor, borderColor: themeColor }"
          @click="_goContact"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-delay="400"
        >
          联系我们
        </el-button>
      </div>
      <!-- 横幅图片位置留空 -->
      <div
        class="banner-image"
        :style="{ backgroundImage: `url(${companyInfo.bannerImage})` }"
      ></div>
    </section>

    <!-- 公司概况 -->
    <section
      class="company-overview"
      data-aos="fade-up"
      data-aos-duration="800"
    >
      <div class="container">
        <h2 class="section-title">公司概况</h2>
        <el-row :gutter="40">
          <el-col :xs="24" :md="12">
            <!-- 公司简介图片位置留空 -->
            <div class="overview-image" v-if="companyInfo.overviewImage">
              <img :src="companyInfo.overviewImage" alt="公司简介" />
            </div>
          </el-col>
          <el-col :xs="24" :md="12">
            <div class="overview-content">
              <h3>关于我们</h3>
              <p>{{ companyInfo.overview }}</p>

              <div class="stats-grid">
                <div
                  class="stat-item"
                  v-for="(stat, index) in companyStats"
                  :key="index"
                >
                  <div class="stat-value" :style="{ color: themeColor }">
                    {{ stat.value }}
                  </div>
                  <div class="stat-label">
                    {{ stat.label }}
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </section>

    <!-- 发展历程 -->
    <section class="company-history" data-aos="fade-up" data-aos-duration="800">
      <div class="container">
        <h2 class="section-title">发展历程</h2>
        <div class="timeline-container">
          <div
            class="timeline-item"
            v-for="(event, index) in companyHistory"
            :key="index"
            :class="{ 'right-side': index % 2 !== 0 }"
            data-aos="fade-right"
            data-aos-duration="800"
            :data-aos-delay="index * 200"
          >
            <div class="timeline-content">
              <div class="timeline-date">{{ event.year }}</div>
              <h3>{{ event.title }}</h3>
              <p>{{ event.description }}</p>
            </div>
            <div
              class="timeline-marker"
              :style="{ backgroundColor: themeColor }"
            ></div>
          </div>
        </div>
      </div>
    </section>

    <!-- 企业文化 -->
    <section class="company-culture" data-aos="fade-up" data-aos-duration="800">
      <div class="container">
        <h2 class="section-title">企业文化</h2>
        <el-row :gutter="30">
          <el-col
            :xs="24"
            :sm="12"
            :md="6"
            v-for="(culture, index) in companyCulture"
            :key="index"
          >
            <div
              class="culture-card"
              data-aos="zoom-in"
              data-aos-duration="600"
              :data-aos-delay="index * 200"
            >
              <!-- <div class="culture-icon"> -->
              <!-- 图标位置留空 -->
              <!-- <img :src="culture.icon" alt="culture icon" /> -->
              <!-- </div> -->
              <h3>{{ culture.title }}</h3>
              <p>{{ culture.description }}</p>
            </div>
          </el-col>
        </el-row>
      </div>
    </section>

    <!-- 团队介绍 -->
    <!-- <section class="company-team" data-aos="fade-up" data-aos-duration="800">
      <div class="container">
        <h2 class="section-title">核心团队</h2>
        <el-carousel
          :interval="5000"
          arrow="always"
          height="400px"
          class="team-carousel"
          indicator-position="outside"
        >
          <el-carousel-item v-for="(member, index) in teamMembers" :key="index">
            <div class="team-member">
              <div class="member-avatar">
                <img :src="member.avatar" :alt="member.name" />
              </div>
              <div class="member-info">
                <h3>{{ member.name }}</h3>
                <div class="member-position">{{ member.position }}</div>
                <p>{{ member.description }}</p>
                <div class="member-skills">
                  <el-tag
                    v-for="(skill, sIndex) in member.skills"
                    :key="sIndex"
                    :style="{
                      backgroundColor: themeColor,
                      borderColor: themeColor,
                      color: '#fff',
                    }"
                    size="small"
                    class="skill-tag"
                  >
                    {{ skill }}
                  </el-tag>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </section> -->

    <!-- 合作伙伴 -->
    <!-- <section
      class="company-partners"
      data-aos="fade-up"
      data-aos-duration="800"
    >
      <div class="container">
        <h2 class="section-title">合作伙伴</h2>
        <el-carousel
          :interval="3000"
          arrow="hover"
          height="120px"
          class="partners-carousel"
        >
          <el-carousel-item
            v-for="(group, index) in partnerGroups"
            :key="index"
          >
            <div class="partners-group">
              <div
                class="partner-logo"
                v-for="(partner, pIndex) in group"
                :key="pIndex"
                :style="{ backgroundImage: `url(${partner.logo})` }"
              ></div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </section> -->

    <!-- 联系我们 -->
    <!-- <section class="company-contact" data-aos="fade-up" data-aos-duration="800">
      <div class="container">
        <h2 class="section-title">联系我们</h2>
        <el-row :gutter="40">
          <el-col :xs="24" :md="12">
            <div class="contact-info">
              <div class="info-item">
                <i class="el-icon-location" :style="{ color: themeColor }"></i>
                <div class="info-content">
                  <h4>公司地址</h4>
                  <p>{{ companyInfo.address }}</p>
                </div>
              </div>
              <div class="info-item">
                <i class="el-icon-phone" :style="{ color: themeColor }"></i>
                <div class="info-content">
                  <h4>联系电话</h4>
                  <p>{{ companyInfo.phone }}</p>
                </div>
              </div>
              <div class="info-item">
                <i class="el-icon-message" :style="{ color: themeColor }"></i>
                <div class="info-content">
                  <h4>电子邮箱</h4>
                  <p>{{ companyInfo.email }}</p>
                </div>
              </div>
              <div class="info-item">
                <i class="el-icon-time" :style="{ color: themeColor }"></i>
                <div class="info-content">
                  <h4>工作时间</h4>
                  <p>{{ companyInfo.workTime }}</p>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form
              :model="contactForm"
              :rules="contactRules"
              ref="contactForm"
              label-width="100px"
              class="contact-form"
            >
              <el-form-item label="姓名" prop="name">
                <el-input
                  v-model="contactForm.name"
                  placeholder="请输入您的姓名"
                ></el-input>
              </el-form-item>
              <el-form-item label="公司" prop="company">
                <el-input
                  v-model="contactForm.company"
                  placeholder="请输入公司名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="电话" prop="phone">
                <el-input
                  v-model="contactForm.phone"
                  placeholder="请输入联系电话"
                ></el-input>
              </el-form-item>
              <el-form-item label="邮箱" prop="email">
                <el-input
                  v-model="contactForm.email"
                  placeholder="请输入电子邮箱"
                ></el-input>
              </el-form-item>
              <el-form-item label="需求" prop="message">
                <el-input
                  type="textarea"
                  :rows="4"
                  v-model="contactForm.message"
                  placeholder="请描述您的需求"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  :style="{
                    backgroundColor: themeColor,
                    borderColor: themeColor,
                  }"
                  @click="submitContactForm"
                  class="submit-btn"
                >
                  提交需求
                </el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
    </section> -->
  </div>
</template>

<script>
export default {
  name: "CompanyIntro",
  data() {
    return {
      themeColor: "#f97d01",

      // 公司基本信息
      companyInfo: {
        name: "河南善信医养科技有限公司",
        slogan: "科技赋能民生,服务助力养老",
        bannerImage: "https://upload.shanxinyy.com/homepage/jinrongdashaBj.jpg", // 替换为横幅图片路径
        overviewImage:
          "https://upload.shanxinyy.com/homepage/jinrongdashaBj.jpg", // 替换为公司简介图片路径
        overview:
          "河南善信医养科技有限公司成立于2019年，是一家专注于智慧医养领域的国家科小企业。公司秉承科技赋能名声，服务助力养老的核心使命，致力于为客户提供优质的服务。经过多年的发展，我们已经建立了完善的产品体系和服务网络，为老人提供一站式养老服务。",
        address: "河南省鹤壁市淇滨区金融大厦702",
        phone: "134 0392 2611",
        email: "397626534@qq.com",
        workTime: "周一至周六 8:30-17:30",
      },

      // 公司统计数据
      companyStats: [
        { value: "10+", label: "年行业经验" },
        { value: "300+", label: "服务客户" },
        { value: "50+", label: "专业团队" },
        { value: "100%", label: "客户满意度" },
      ],

      // 发展历程
      companyHistory: [
        {
          year: "2025",
          title: "业务拓展",
          description:
            "成功开拓线下市场，建立社区医养服务中心,提供一站式智慧养老服务。",
        },
        {
          year: "2024",
          title: "技术迭代全面升级",
          description:
            "研发新一代善信智慧医养助残平台,精准匹配市场需求，提升用户体验。",
        },
        {
          year: "2020",
          title: "技术创新",
          description:
            "推出第一代善信智慧医养助残平台，获得多项国家专利，技术实力再上新台阶。",
        },
        {
          year: "2018",
          title: "快速发展",
          description:
            "基于对智慧养老行业的深度调研与需求分析，我们精准捕捉市场服务缺口，整合AIoT、大数据等前沿技术，自主研发‘善信智慧医养助残平台’，为老年群体及残障人士提供智能化、个性化、全周期的健康管理解决方案。",
        },
        {
          year: "2016",
          title: "公司成立",
          description:
            "善信科技（北京）有限公司正式成立，专注于智慧养老服务领域的技术研发和服务。",
        },
      ],

      // 企业文化
      companyCulture: [
        {
          icon: "", // 替换为图标路径
          title: "创新",
          description: "持续创新，追求卓越，用科技改变世界。",
        },
        {
          icon: "", // 替换为图标路径
          title: "专业",
          description: "专业团队，专业服务，为客户创造最大价值。",
        },
        {
          icon: "", // 替换为图标路径
          title: "合作",
          description: "开放合作，携手共赢，共同推动行业发展。",
        },
        {
          icon: "", // 替换为图标路径
          title: "责任",
          description: "承担社会责任，回馈社会，做有担当的企业。",
        },
      ],

      // 团队成员
      teamMembers: [
        {
          avatar: "", // 替换为头像路径
          name: "张三",
          position: "创始人兼CEO",
          description:
            "拥有15年行业经验，曾就职于知名科技公司，主导多个大型项目。",
          skills: ["战略规划", "团队管理", "市场拓展"],
        },
        {
          avatar: "", // 替换为头像路径
          name: "李四",
          position: "CTO",
          description: "技术专家，专注于XX领域技术研发，拥有多项技术专利。",
          skills: ["技术研发", "架构设计", "技术创新"],
        },
        {
          avatar: "", // 替换为头像路径
          name: "王五",
          position: "产品总监",
          description: "资深产品经理，擅长从用户需求出发打造优秀产品。",
          skills: ["产品设计", "用户体验", "需求分析"],
        },
        {
          avatar: "", // 替换为头像路径
          name: "赵六",
          position: "市场总监",
          description: "市场营销专家，拥有丰富的品牌推广和市场运营经验。",
          skills: ["品牌推广", "市场运营", "商务合作"],
        },
      ],

      // 合作伙伴（分组显示，每组4个）
      // partnerGroups: [
      //   [
      //     { logo: "" }, // 替换为合作伙伴logo路径
      //     { logo: "" },
      //     { logo: "" },
      //     { logo: "" },
      //   ],
      //   [{ logo: "" }, { logo: "" }, { logo: "" }, { logo: "" }],
      // ],

      // 联系表单数据
      contactForm: {
        name: "",
        company: "",
        phone: "",
        email: "",
        message: "",
      },

      // 表单验证规则
      contactRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: "请输入电子邮箱", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  mounted() {
    // 初始化AOS动画库
    this.$nextTick(() => {
      import("aos").then((AOS) => {
        AOS.init({
          duration: 800,
          once: true,
        });
      });
    });
  },
  methods: {
    scrollToContact() {
      const contactSection = document.querySelector(".company-contact");
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: "smooth" });
      }
    },
    submitContactForm() {
      this.$refs.contactForm.validate((valid) => {
        if (valid) {
          // 这里添加表单提交逻辑
          this.$message.success("提交成功，我们会尽快与您联系！");
          this.$refs.contactForm.resetFields();
        } else {
          this.$message.error("请填写完整且正确的信息");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
/* 基础样式 */
.company-intro-container {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", Arial, sans-serif;
  color: #333;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

.section-title {
  font-size: 32px;
  color: #333;
  text-align: center;
  margin-bottom: 50px;
  font-weight: 500;
  position: relative;
  padding-bottom: 15px;
}

.section-title::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background-color: #f97d01;
}

/* 公司横幅样式 */
.company-banner {
  position: relative;
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  overflow: hidden;
}

.banner-content {
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 800px;
  padding: 0 20px;
}

.banner-content h1 {
  font-size: 48px;
  margin-bottom: 20px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

.banner-content p {
  font-size: 20px;
  margin-bottom: 40px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

.banner-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  z-index: 1;
}

.banner-image::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: -1;
}

/* 公司概况样式 */
.company-overview {
  padding: 80px 0;
}

.overview-image {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.overview-image img {
  width: 100%;
  display: block;
}

.overview-content {
  padding-top: 20px;
}

.overview-content h3 {
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
}

.overview-content p {
  line-height: 1.8;
  color: #666;
  margin-bottom: 30px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.stat-item {
  text-align: center;
  padding: 20px;
  border-radius: 8px;
  background-color: #f9f9f9;
}

.stat-value {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 10px;
}

.stat-label {
  font-size: 14px;
  color: #666;
}

/* 发展历程样式 */
.company-history {
  padding: 80px 0;
  background-color: #f9f9f9;
}

.timeline-container {
  position: relative;
  padding: 40px 0;
}

.timeline-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 2px;
  height: 100%;
  background-color: #e0e0e0;
}

.timeline-item {
  position: relative;
  width: 50%;
  padding-right: 40px;
  margin-bottom: 60px;
}

.timeline-item.right-side {
  left: 50%;
  padding-right: 0;
  padding-left: 40px;
}

.timeline-content {
  background-color: white;
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  position: relative;
}

.timeline-content::before {
  content: "";
  position: absolute;
  top: 20px;
  right: -15px;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 15px solid white;
}

.timeline-item.right-side .timeline-content::before {
  right: auto;
  left: -15px;
  border-left: none;
  border-right: 15px solid white;
}

.timeline-date {
  font-size: 14px;
  color: #f97d01;
  margin-bottom: 10px;
  font-weight: 500;
}

.timeline-content h3 {
  font-size: 20px;
  margin-bottom: 10px;
  color: #333;
}

.timeline-content p {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
}

.timeline-marker {
  position: absolute;
  top: 20px;
  right: -8px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #f97d01;
  z-index: 2;
}

.timeline-item.right-side .timeline-marker {
  right: auto;
  left: -8px;
}

/* 企业文化样式 */
.company-culture {
  padding: 80px 0;
}

.culture-card {
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 30px;
  transition: all 0.3s ease;
}

.culture-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.culture-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(249, 125, 1, 0.1);
  border-radius: 50%;
}

.culture-icon img {
  max-width: 50%;
  max-height: 50%;
}

.culture-card h3 {
  font-size: 20px;
  margin-bottom: 15px;
  color: #333;
}

.culture-card p {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
}

/* 团队介绍样式 */
.company-team {
  padding: 80px 0;
  background-color: #f9f9f9;
}

.team-carousel {
  margin-top: 40px;
}

.team-member {
  display: flex;
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  height: 100%;
}

.member-avatar {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 30px;
  flex-shrink: 0;
}

.member-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.member-info {
  flex: 1;
}

.member-info h3 {
  font-size: 24px;
  margin-bottom: 5px;
  color: #333;
}

.member-position {
  font-size: 16px;
  color: #f97d01;
  margin-bottom: 15px;
}

.member-info p {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
  margin-bottom: 20px;
}

.member-skills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

/* 合作伙伴样式 */
.company-partners {
  padding: 80px 0;
}

.partners-carousel {
  margin-top: 40px;
}

.partners-group {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 100%;
}

.partner-logo {
  width: 150px;
  height: 80px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  opacity: 0.8;
  transition: all 0.3s ease;
}

.partner-logo:hover {
  opacity: 1;
  transform: scale(1.05);
}

/* 联系我们样式 */
.company-contact {
  padding: 80px 0;
}

.contact-info {
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.info-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 25px;
  padding-bottom: 25px;
  border-bottom: 1px solid #eee;
}

.info-item:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.info-item i {
  font-size: 24px;
  margin-right: 15px;
  margin-top: 5px;
  flex-shrink: 0;
}

.info-content h4 {
  font-size: 18px;
  margin-bottom: 8px;
  color: #333;
}

.info-content p {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}

.contact-form {
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.submit-btn {
  width: 100%;
  margin-top: 10px;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .banner-content h1 {
    font-size: 32px;
  }

  .banner-content p {
    font-size: 16px;
  }

  .section-title {
    font-size: 28px;
    margin-bottom: 30px;
  }

  .timeline-item {
    width: 100%;
    left: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin-bottom: 40px;
  }

  .timeline-container::before {
    left: 20px;
  }

  .timeline-marker {
    left: 12px !important;
  }

  .timeline-content {
    margin-left: 60px;
  }

  .timeline-content::before {
    left: -15px !important;
    right: auto !important;
    border-left: 15px solid white !important;
    border-right: none !important;
  }

  .team-member {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .member-avatar {
    margin-right: 0;
    margin-bottom: 20px;
    width: 120px;
    height: 120px;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }
}
</style>
